module.exports = __webpack_public_path__ + "img/num_21.f142d171.png";